/* The prototype's pill toggle. A real checkbox sits on top at full size and
   zero opacity, so it keeps native keyboard and screen-reader behaviour while
   the two spans do the drawing. */
export function BbSwitch({
  id,
  checked,
  onChange,
  disabled,
  label,
}: {
  id: string
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  /** Used when the visible text lives elsewhere, e.g. in a settings row. */
  label: string
}) {
  return (
    <span className="bb-switch">
      <input
        id={id}
        type="checkbox"
        role="switch"
        aria-label={label}
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className="bb-switch-t" />
    </span>
  )
}
